import {get} from '../utils'
import {includeQuery} from './utils';
import {getActiveChannel} from "../authentication/utils";

export default host => (id, include = includeQuery) =>
  get(`${host}${getActiveChannel() ? `/channels/${getActiveChannel()}` : ""}/playlists/${id}?${include}`)
  .then(response => response.json())
  .then(json => json.data)
